import * as React from 'react';
import { CustomButton, ButtonType } from "soprasteria-ui-library";
import { IRiskPotReportAttachment } from '../../../models/IRiskPotReport';
import { useAuth } from '../../../App';
import { RiskPotReportDocumentApi } from '../../../api/RiskPotReportDocumentApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faTrash } from '@fortawesome/free-solid-svg-icons';

interface IRiskPotReportAttachmentsTable {
    attachments: IRiskPotReportAttachment[];
    setShowForm: React.Dispatch<React.SetStateAction<boolean>>;
    canBeEdited: boolean;
    hasRoleAllmäntandvård: boolean;
    changeSuccessMessage: (message: string) => void;
    getRiskPotReport: () => void;
}

export const RiskPotReportAttachmentsTable: React.FunctionComponent<IRiskPotReportAttachmentsTable> = ({ attachments, setShowForm, canBeEdited, hasRoleAllmäntandvård, changeSuccessMessage, getRiskPotReport }) => {

    const auth = useAuth();
    const api = new RiskPotReportDocumentApi(auth);

    const removeFile = (id: number) => {
        const removeFileFromDB = window.confirm("Är du säker på att du vill ta bort den här bilagan?");
        if (removeFileFromDB) {
            api.removeRiskPotReportAttachment(id.toString(), () => {
                changeSuccessMessage("Dokumentet har tagits bort");
                getRiskPotReport();
            });
        }
    }

    const hasDownloadableDocuments = () => {
        if (attachments) {
            return attachments.some(data => data.isDownloadable);
        } else {
            return false;
        }
    }

    const downloadAllDocuments = () => {
        if (attachments) {
            let downloadableAttachments = attachments.filter(data => data.isDownloadable);
            downloadableAttachments.forEach((riskPotReportAttachment) => {
                downloadDocument(riskPotReportAttachment.riskPotReportAttachmentId, riskPotReportAttachment.name);
            });
        }        
    }

    const downloadDocument = (riskPotReportAttachmentId: number, fileName?: string) => {
        api.downloadRiskPotReportAttachment(riskPotReportAttachmentId, fileName,
            (error) => {
                alert(error);
            });
    }

    const isAnyAttachmentRemovable = () => {
        return attachments.some((attachment) => attachment.canBeRemoved);
    }

    const isPhysicalAttachment = (attachment: IRiskPotReportAttachment) => {
        return attachment.quantity !== null;
    }

    const renderAttachmentRow = (attachment: IRiskPotReportAttachment, key: number) => {
        return <li key={key} className="row" onClick={() => downloadDocument(attachment.riskPotReportAttachmentId, attachment.name)} title={`Ladda ner ${attachment.name}`}>
            <div className={`col-11 ${!isPhysicalAttachment(attachment) ? "download" : ""}`}>
                <div className="row">
                    <p className="col-6">{attachment.name}</p>
                    <p className="col-2">{attachment.riskPotReportAttachmentCategory}</p>
                    <p className="col-1">{attachment.quantity}</p>
                    {
                        isPhysicalAttachment(attachment)
                            ? <p className="col-2">Fysisk bilaga</p>
                            : <span className="col-2 download-icon"><button><FontAwesomeIcon icon={faDownload} /></button></span>
                    }
                </div>
            </div>
            {
                attachment.canBeRemoved ?
                    <span className="col-1 remove-icon" onClick={(e) => {
                        e.stopPropagation();
                        removeFile(attachment.riskPotReportAttachmentId);
                    }}><button><FontAwesomeIcon icon={faTrash} /></button></span>
                    : <span className="col-1"></span>
            }
        </li>
    }

    return (
        <div>
            <div className="row panel">
                <div className="col-6 text-left">
                    <h5>Uppladdade dokument</h5>
                </div>
                {
                    hasRoleAllmäntandvård && canBeEdited ?
                        <div className="col-6 text-right">
                            <CustomButton buttonType={ButtonType.create} buttonText="Lägg till dokument" data-toggle="modal" data-target="#risk-pot-attachment-modal" id="open-risk-pot-attachment-modal" onClick={() => setShowForm(true)} />
                        </div>
                        : null
                }
            </div>
            {
                attachments && attachments?.length > 0
                    ?
                    <>
                        <div className="row">
                            <div className="col-11">
                                <div className="row">
                                    <h6 className="col-6">Fil</h6>
                                    <h6 className="col-2">Typ av bilaga</h6>
                                    <h6 className="col-1">Antal</h6>
                                    <h6 className="col-2">Ladda ner</h6>
                                </div>
                            </div>
                            {
                                isAnyAttachmentRemovable() ?
                                    <div className="col-1">
                                        <h6>Ta bort</h6>
                                    </div>
                                    : null
                            }
                        </div>
                        <ul className="list-no-styling document-download-list">
                            {
                                attachments?.map((attachment, index) =>
                                    renderAttachmentRow(attachment, index)
                                )
                            }
                        </ul>
                        <div className="row">
                            <div className="col-11">
                                <div className="row">
                                    <CustomButton disabled={!hasDownloadableDocuments()} 
                                        title={!hasDownloadableDocuments() ? "Det finns inga nerladdningsbara dokument" : ""} 
                                        buttonType={ButtonType.download} 
                                        buttonText="Ladda ner alla dokument" 
                                        onClick={() => downloadAllDocuments()} />
                                </div>
                            </div>
                        </div>
                    </>
                    : null
            }
        </div>
    )

}